<template>
    <div class="main">
        <div class="top">
            <div class="classify">
                <div class="c-list">
                    <img src="/static/img/classify.png" class="c-img">
                    <div class="c-name">领域分类</div>
                </div>
            </div>
            <div class="classify-list">
                <div class="list-box">
                    <div :class="checkNum === 0 ? 'list-sel' : 'list-not'" @click="selAll">全部</div>
                    <div :class="checkNum == item.id ? 'list-sel' : 'list-not'" v-for="(item,index) in tabList" :key="index" @click="selClassify(item.id)">{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="left">
                <div class="body-top">
                    <div class="c-list">
                        <img src="/static/img/classify.png" class="c-img">
                        <div class="c-name">筛选条件</div>
                    </div>
                    <selectCity style="margin-left:10px;">
                        <div class="c-list" ><!-- @click="changeTag(false)" -->
                            <img src="/static/img/address.png" class="c-img">
                            <div class="c-name">{{$store.state.locationCity.length ? $store.state.locationCity[$store.state.locationCity.length - 1] : '定位中...'}}</div>
                            <img src="/static/img/down.png" class="c-img">
                        </div>
                    </selectCity>
                    <el-select v-model="district" placeholder="区域" size="small" style="width: 104px;margin-left:10px; " @change = getDistrict :clearable= isDistrict >
                        <p style="width:104px;height: 1px">&nbsp;</p>
                        <el-option
                        v-for="item in childDistrict"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="lawOfficeValue" popper-class="starAttorney-scope-show" placeholder="律所" size="small" style="width: 250px; height: 32px;margin-left:10px;" :clearable= isLawOfficeValue @change="getcompany">
                        <el-input class="iptstyle" size="small"  placeholder="输入关键字搜索..." prefix-icon="el-icon-search" v-model="str"></el-input>
                        <el-option
                            v-for="(item, index) in Arrlist"
                            :key="index"
                            :label="item.company"
                            :value="item.company">
                        </el-option>
                    </el-select>
                    <el-select v-if="isLogin" v-model="followed"  placeholder="是否关注" size="small" style="width: 104px;margin-left:10px; " @change="getfollowed">
                        <el-option
                                v-for="(item, index) in followList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="body-table">
                    <el-table :data="list" class="table" v-loading="loading">
                        <el-table-column label="头像" width="90">
                            <template slot-scope="scope">
                                <img :src="$avatarHash(scope.row.id)" class="t-img" @click="$router.push({name: 'personalCenter', params: {id: scope.row.id}})">
                                <img v-if="scope.row.is_seeds" src="/static/img/isSeedUser.png" class="t-isSeed">
                                <img v-if="scope.row.is_vip" src="/static/img/isviplawyer.png" class="t-vip">
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" width="160">
                            <template slot-scope="scope">
                                <div class="table-name">
                                    <div>{{scope.row.name}}</div>
                                    <div v-if="scope.row.is_seeds">(种子用户)</div>
                                    <img src="/static/img/islawyer.png" class="t-name-img">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="专业领域" width="230">
                            <template slot-scope="scope">
                                <span v-for="(item , index) in scope.row.speciality">{{item}}<span v-if="index + 1 != scope.row.speciality.length">/</span></span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="post_num" label="知识数"  width="75"></el-table-column>
                        <el-table-column prop="case_num" label="案件数"  width="75"></el-table-column>
                        <el-table-column label="星级" width="150">
                            <template slot-scope="scope">
                                <el-rate v-model="scope.row.star" disabled disabled-void-color="#FFF5E4"></el-rate>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" v-if="scope.row.followed == 0" class="table-btn" @click="follow(scope.row.id,scope.$index)">关注</el-button>
                                <el-button type="info" v-else class="table-btn" @click="unfollow(scope.row.id,scope.$index)">已关注</el-button>
                                <el-button class="table-btn" @click="gotoChat(scope.row.id)">咨询</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="l-page" v-if="total > perpage">
                    <el-pagination
                    background
                    :current-page.sync="pageIndex"
                    :page-size="perpage"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next, total"
                    :total="total">
                </el-pagination>
            </div>
            <div v-else class="l-page">
                没有更多了
            </div>
            </div>
            <div class="right">
                <div class="r-list">
                    <div class="r-title">周活跃律师</div>
                    <div class="r-list">
                        <div v-for="(item , index) in weekList" :key="index" class="r-img-list">
                            <img :src="$avatarHash(item.id)" class="table-icon" @mouseenter.stop="userInfoModule(item.id, $event)" @mouseleave.stop="hideModule" @click="$router.push({name: 'personalCenter', params: {id: item.id}})">
                        </div>
                    </div>
                </div>
                <div class="r-list">
                    <div class="r-title">最新入驻律师</div>
                    <div class="r-list">
                        <div v-for="(item , index) in newList" :key="index" class="r-img-list">
                            <img :src="$avatarHash(item.id)" class="table-icon" @mouseenter="userInfoModule(item.id, $event)" @mouseleave="hideModule" @click="$router.push({name: 'personalCenter', params: {id: item.id}})">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <userInfo
                v-show="isShow"
                :flowModule="true"
                :userList = 'userList'
                ref="infoModule"
        ></userInfo>
    </div>
</template>

<script>
import userInfo from '@/components/userInfo';
import selectCity from "@/components/selectCity";
export default {
    name: 'Lawyer',
    data () {
        return {
            tabList:[],
            checkNum : 0,
            list:[],
            pageIndex:1,
            total:0,
            perpage: 10,
            weekList:[],
            newList:[],
            str:'',
            userList: {}, // 个人详细信息
            isShow: false,
            district:'',   //选择区域
            childDistrict: [],
            lawOfficeValue:'',  //选择的律所
            lawOfficeList: [], //律师事务所
            str:'',
            // Arrlist:[],
            followed:null,
            followList:[{name:'全部',id:null},{name:'关注',id:1},{name:'未关注',id:0}],
            loading:false,
        }
    },
    components: {userInfo,selectCity},
    computed:{
        positionCity() {
                return this.$store.state.locationCity;
        },
        isLogin() {
                return this.$store.state.loginStatus;
        },
        isDistrict() {
                if (this.district == null || this.district == undefined || this.district == '') {
                        return false
                } else {
                        return true
                }
        },
        isLawOfficeValue() {
                if(this.lawOfficeValue == null || this.lawOfficeValue == undefined || this.lawOfficeValue == '') {
                        return false
                } else {
                        return true
                }
        },
        Arrlist() {
                return this.lawOfficeList.filter((value) => {
                        return (value.company || '').includes(this.str)
                })

        },
    },
    mounted(){
        this.str = '';
        let arr = this.positionCity;
        let city = arr[0] && arr[0].indexOf('市') == -1? '': arr[0] + '-';
        let str = city + arr.join('-');
        this.getTagList();
        this.getWeekAttorney(str);
        this.getNewAttorney(str);
        this.getLawyerList(str);
        this.getLawOffice(str);
        this.getGPS(str);
    },
    methods:{
        //获取标签列表
        getTagList(){
            let url = 'home/lawyer/getTopCategory';
            this.$http.get(url).then(res => {
                if(res.data.retcode == $conf.RETCODE_OK){
                    this.tabList = res.data.data;
                }
            })
        },
        //获取周活跃律师
        getWeekAttorney(city) {
                let url = `findlawyer/weekactivelawyer`
                let option = {
                        // tagid: this.tagid,
                        position: city
                }
                // if(this.checkNum == null) {
                //     // console.log('null')

                // } else {
                //     option.tagid = this.tagid
                // }

                this.$ajax('get',url,option, res => {
                        // console.log(res)
                        this.weekList = res.data
                })

        },
        //获取新入驻律师
        getNewAttorney(city) {
                let url = 'findlawyer/recentlyenterlawyer'
                let option = {
                        position: city
                }
                // if (this.tagid == null) {

                // } else {
                //     option.tagid = this.tagid
                // }
                this.$ajax('get', url, option, res => {
                        this.newList = res.data
                })
        },
        //获取律师列表
        getLawyerList(city){
            this.loading = true;
            let url = 'findlawyer/lawyerlist';
            let option = {
                                position: city,
                                per_page: this.perpage,
                                page: this.pageIndex
                };
                if (this.checkNum !== 0) {
                        option.tag_id = this.checkNum;
                };
                if (this.lawOfficeValue == null || this.lawOfficeValue == '') {

                } else {
                        option.law_office = this.lawOfficeValue;
                };
                if(this.followed == null){

                }else{
                    option.followed = this.followed;
                };
                this.$ajax('get', url, option, res => {
                        if (res.data.length == 0) {
                                this.list = [];
                                this.total = 0;
                                return false;
                        };
                        if (res.data.data.length > 0) {
                                res.data.data.forEach((item) => {
                                        if (item.followed == undefined) {
                                                item.followed = 0;
                                        }
                                })
                        };
                        // console.log('1111',res.data);
                        this.list = res.data.data;
                        this.total = res.data.total;
                        this.loading = false;
                })
        },
        // 关注
        follow(id,index) {
            if( !this.isLogin ){
                this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
                return;
            }
            this.$ajax('post', 'user/follow/' + id, data => {
                this.list[index].followed = 1;
                this.$message.success( '关注成功！' );
            });
        },
        // 取关
        unfollow(id,index) {
            this.$ajax('post', 'user/unfollow/' + id, data => {
                this.list[index].followed = 0;
                this.$message.success( '已取消关注！' );
            });
        },
        userInfoModule(item, s) {
                let _this = this
                let e = s || window.event
                let url = `userinfo/detail/${item}`
                let option = {}
                this.timeOut = setTimeout(() => {

                        _this.$ajax('get', url, option, res => {
                                // console.log(res.data)
                                res.data.isStar = (5 - res.data.star)
                                this.userList = res.data
                                // console.log(e, 1)
                                 _this.$nextTick(() => {
                                        //  console.log(e, 1)
                                        _this.$refs.infoModule.boxCard(item,e);
                                        _this.isShow = true
                                });
                        })

                }, 500)



        },
        hideModule() {
                clearTimeout(this.timeOut)
                this.isShow = false
        },
        //全选
        selAll(){
            this.checkNum = 0;
            this.pageIndex = 1;
            let arr = this.positionCity;
            let city = arr[0] && arr[0].indexOf('市') == -1? '': arr[0] + '-';
            let str
            if (this.district == '' || this.district == null || this.district == undefined) {
                    str = city + arr.join('-');
            } else {
                    str = city + arr.join('-') + '-' + this.district;
            };
            this.getLawyerList(str);
        },
        //选择标签
        selClassify(id){
            this.checkNum = id;
            this.pageIndex = 1;
            let arr = this.positionCity;
            let city = arr[0] && arr[0].indexOf('市') == -1? '': arr[0] + '-';
            let str
            if (this.district == '' || this.district == null || this.district == undefined) {
                    str = city + arr.join('-');
            } else {
                    str = city + arr.join('-') + '-' + this.district;
            };
            this.getLawyerList(str);
        },
        handleCurrentChange(val) {
                this.pageIndex = val;
                let arr = this.positionCity;
            let city = arr[0] && arr[0].indexOf('市') == -1? '': arr[0] + '-';
            let str
            if (this.district == '' || this.district == null || this.district == undefined) {
                    str = city + arr.join('-');
            } else {
                    str = city + arr.join('-') + '-' + this.district;
            };
                this.getLawyerList(str);
        },
        //选择区域
        getDistrict() {
                this.pageIndex = 1;
                let arr = this.positionCity;
                let city = arr[0] && arr[0].indexOf('市') == -1? '': arr[0] + '-';
                let str
                if (this.district == '') {
                        str = city + arr.join('-')
                } else {
                        str = city + arr.join('-') + '-' + this.district
                }
                this.getLawyerList(str)
                this.getLawOffice(str)
        },
        //获取律所
        getLawOffice(city) {
                let url = 'findlawyer/lawofficelist'
                let option = {
                        position: city
                        // page:1,
                        // per_page:10
                }
                this.$ajax('get', url ,option, res => {
                    this.lawOfficeList = res.data;
                })
        },
        //获取区域
        getGPS(str) {
                let url = 'district/getdistrictjson';
                let arr = [];
                if (this.$store.state.placeData.length) {
                        let arr = this.positionCity;
                        let city
                        if (arr[0] === '全国') {
                                city = '全国'
                        }
                        if (arr[0].indexOf('市') > -1) {
                                city = arr[0]
                        } else {
                                city = arr[1]
                        };
                        this.$store.state.placeData.forEach((item, index) => {
                                item.children.forEach((child, i) => {
                                        if (child.value == city) {
                                                this.childDistrict = child.children;

                                        }
                                })
                        })
                } else {
                        this.$http.get(url).then(res => {
                                if (res.status == 200 && res.data.retcode == 0) {
                                        let data = JSON.parse(res.data.data.district)
                                        data.forEach((item, index) => {
                                                item.children.forEach((child, i) => {
                                                        if (child.value == str) {
                                                                this.childDistrict = child.children;
                                                        }
                                                })

                                        })
                                }
                        })
                }

        },
        //选择律所事件
        getcompany() {
                this.pageIndex = 1
                let arr = this.positionCity
                let city = arr[0] && arr[0].indexOf('市') == -1? '': arr[0] + '-';
                if (this.lawOfficeValue == '') {
                        this.lawOfficeValue = null
                }
                if (this.district == '') {
                        this.district = null
                }
                let str
                if (this.district == '' || this.district == null) {
                        str = city + arr.join('-')
                } else {

                        str = city + arr.join('-') + '-' + this.district
                };
                this.getLawyerList(str)

        },
        //选择是否关注事件
        getfollowed(){
            this.pageIndex = 1
                let arr = this.positionCity
                let city = arr[0] && arr[0].indexOf('市') == -1? '': arr[0] + '-';
                if (this.lawOfficeValue == '') {
                        this.lawOfficeValue = null
                }
                if (this.district == '') {
                        this.district = null
                }
                let str
                if (this.district == '' || this.district == null) {
                        str = city + arr.join('-')
                } else {

                        str = city + arr.join('-') + '-' + this.district
                };
                this.getLawyerList(str)
        },
        gotoChat(id) {
            if( !this.isLogin ){
                this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
                setTimeout(() => {
                    this.$message.warning( '请先登录后，再次执行操作！' );
                }, 200);
                return;
            }
            // this.$gotov1('/feed?v2chat=' + this.userInfo.id);
            this.startGetInfo(id)

        },

        startGetInfo(uid) {
            this.$ajax('get', `/userinfo/detail/${uid}`, (data) => {
                    this.startChat(data.data);
            });
        },
        startChat(user) {
                if(this.$store.state.mineInfo && this.$store.state.mineInfo.id){
                        this.$store.commit("changeCurcontactInfo", { id: user.id, name: user.name});

                        if(!this.isshowchatpanel){
                                this.$store.commit('setSide', 'chat');
                        }
                }else{
                        this.$Message.error('未登录，请先登录后再发起私信！');
                }
        },
    },
    watch:{
        positionCity: {
            deep: true,
            handler(v, ov) {
                this.district = '';
                this.lawOfficeValue = '';
                let city = v[0] && v[0].indexOf('市') == -1? '': v[0] + '-'
                city  = city + v.join('-')
                this.getLawyerList(city);
                this.getLawOffice(city);
                let text
                if ((v.length == 1 && v[0].indexOf('省') > -1) || v[0].indexOf('区') > -1 ) {
                        // console.log('进入')
                        this.childDistrict = []
                        return false
                };
                if (v[0].indexOf('市') > -1) {
                        text = v[0]
                } else {
                        text = v[1]
                };
                this.getGPS(text);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
    .top
        padding:67px 15% 0 15%;
        height:206px;
        background:rgba(252,252,252,1);
        .classify
            display:flex;
            align-items:center;
            .c-list
                display:flex;
                align-items:center;
                cursor:pointer;
                .c-img
                    width:22px;
                    height:22px;
                    margin-right:6px;
                .c-name
                    height:22px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(7,19,54,0.8);
                    line-height:22px;
                    margin-right:5px;
        .classify-list
            width:1321px;
            height:59px;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 10px 0px rgba(39,81,203,0.09);
            border-radius:5px;
            margin-top:24px;
            .list-box
                height:59px;
                margin-left:50px;
                display:flex;
                align-items:center;
                .list-sel
                    height:27px;
                    padding:0 10px;
                    line-height:27px;
                    background:rgba(39,81,203,1);
                    border-radius:20px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    text-align:center;
                    margin-right:50px;
                    cursor:pointer;
                .list-not
                    height:27px;
                    padding:0 10px;
                    line-height:27px;
                    border-radius:20px;
                    font-size:14px;
                    font-weight:400;
                    color:#676F86;
                    text-align:center;
                    margin-right:50px;
                    cursor:pointer;
    .body
        margin:0 15%;
        display:flex;
        // min-height 650px;
        .left
            width:1022px;
            border-right:1px solid rgba(242,242,242,1);
            min-height 650px;
            .body-top
                display:flex;
                align-items:center;
                margin-top:43px;
                .c-list
                    display:flex;
                    align-items:center;
                    cursor:pointer;
                    .c-img
                        width:22px;
                        height:22px;
                        margin-right:6px;
                    .c-name
                        height:22px;
                        font-size:16px;
                        font-weight:500;
                        color:rgba(7,19,54,0.8);
                        line-height:22px;
                        margin-right:5px;
            .body-table
                margin-top:30px;
                .table
                    width:988px;
                    .table-name
                        display:flex;
                        align-items:center;
                        .t-name-img
                            width:9px;
                            height:11px;
                            margin-left:4px;
                    .t-img
                        width:56px;
                        height:56px;
                        border-radius:38px;
                        position: relative;
                    .t-isSeed
                        position: absolute;
                        width:40px;
                        height:20px;
                        top:1px;
                        right:32px;
                    .t-vip
                        width:18px;
                        height:18px;
                        position: absolute;
                        right:25px;
                        bottom:20px;      
                    .table-btn
                        width:78px;
                        height:31px;
                        line-height:31px;
                        border-radius:16px;
                        text-align:center;
                        padding:0px;
            .l-page
                margin:70px 0;
                text-align:center;
        .right
            min-width:300px;
            padding:43px 0px 0px 30px;
            .r-list
                margin-bottom:70px;
                .r-title
                    height:22px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(103,111,134,1);
                    line-height:22px;
                .r-list
                    display:flex;
                    flex-wrap: wrap;
                    margin-top:10px;
                    .r-img-list
                        padding:10px;
                        cursor:pointer;
                        .table-icon
                            width:47px;
                            height:47px;
                            border-radius:24px;
</style>


// WEBPACK FOOTER //
// src/components/lawyer/lawyer.vue